import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getDisplayType } from "./items"

const getStartDate = (state, props) => props.startDate
const getEndDate = (state, props) => props.endDate

export const getFileName = createSelector(
  [getPortfolioName, getDisplayType, getViewType, getStartDate, getEndDate],
  (portfolioName, displayType, viewType, startDate, endDate) => `${portfolioName} ${capitalize(displayType)} ${capitalize(viewType)} Risk ${startDate} - ${endDate}`,
)
